import { createSlice } from '@reduxjs/toolkit';

import sources from 'data/sources.json';

import { Reward } from 'types/reward';

/**
 * Reduxスライスの状態を表す型定義です。
 * @typedef {Object} State
 * @property {string} website - ウェブサイトのURL
 * @property {string} support - お問合せのURL
 * @property {string} systemSupport - システムサポートのURL
 * @property {string} lineOfficialAccount - LINE公式アカウントのID
 * @property {string | undefined} relationProject - 関連プロジェクトの名称
 * @property {string} hint - ヒントのURL
 */

type State = {
  website: string;
  support: string;
  systemSupport: string;
  lineOfficialAccount: string;
  relationProject?: string;
  reward: Reward[];
  hint: string;
};

const { relationProject } = sources as unknown as never;

const initialState: State = {
  website: sources.website,
  support: sources.support,
  systemSupport: sources.systemSupport,
  lineOfficialAccount: sources.lineOfficialAccount,
  relationProject,
  reward: sources.reward,
  hint: (sources as any).hint ?? '',
};

/**
 * 外部リンクや関連プロジェクトの情報を管理するReduxスライスを作成します。
 * @type {import('@reduxjs/toolkit').Slice<State>}
 */
const external = createSlice({
  name: 'external',
  /**
   * 初期状態を定義します。
   * @type {State}
   */
  initialState,

  reducers: {},
});

// Action Creator
// export const {  } = external.actions;

// Reducer
export default external.reducer;
